import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-creations',
  templateUrl: './agent-creations.component.html',
  styleUrls: ['./agent-creations.component.css']
})
export class AgentCreationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/agent-creations/agent-creations.component.ts